import {
  WSAvatar,
  WSCard,
  WSControl,
  WSFlexBox,
  WSIconList,
  WSText
} from "@wingspanhq/fe-component-library";
import { Currency } from "@wingspanhq/utils/dist/currency/currencies";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { useMemo } from "react";
import { IPackage } from "../../../../services/users";

type Props = {
  value: boolean;
  onChange: (value: boolean) => void;
  package?: IPackage;
};

export const PremiumPerksPlan: React.FC<Props> = props => {
  const amount = useMemo(() => {
    if (props.value) {
      return (props.package?.amount || 0) / 12;
    }

    return props.package?.amount || 0;
  }, [props.value, props.package?.amount]);

  const currency = (props.package?.currency as Currency) || Currency.USD;

  return (
    <WSCard shimmer={!props.package}>
      <WSFlexBox
        gap="L"
        direction="column"
        alignItems="center"
        justify="center"
        wrap="nowrap"
      >
        <WSFlexBox wrap="nowrap" gap="S" alignItems="center" justify="center">
          <WSAvatar type="wingspan" />
          <WSText weight="medium">Premium Perks</WSText>
        </WSFlexBox>

        <WSFlexBox wrap="nowrap" gap="M" alignItems="center" justify="center">
          <WSText.ParagraphSm color={props.value ? "gray400" : "gray700"}>
            Monthly billing
          </WSText.ParagraphSm>
          <WSControl
            type="switch"
            value={props.value}
            onChange={props.onChange}
            size="S"
          />
          <WSText.ParagraphSm color={props.value ? "gray700" : "gray400"}>
            Annual billing
          </WSText.ParagraphSm>
        </WSFlexBox>

        <WSFlexBox wrap="nowrap" gap="S" alignItems="center" justify="center">
          <WSText.Heading3 weight="book">
            {formatMoney(amount, currency)}
          </WSText.Heading3>
          <WSText.ParagraphSm>
            {props.value
              ? `per month (${formatMoney(
                  props.package?.amount || 0,
                  currency
                )} billed annually)`
              : "per month (billed monthly)"}
          </WSText.ParagraphSm>
        </WSFlexBox>

        <WSIconList
          iconProps={{ name: "check-circle-fill", color: "green400" }}
          items={[
            "Teladoc ($0 per visit)",
            "Health advocate",
            "Financial, legal & tech support",
            "Medical support & savings"
          ]}
          {...{ style: { maxWidth: 320 } }}
        />
      </WSFlexBox>
    </WSCard>
  );
};
